import { ITransaction } from '../payoutTickets.types'

export const getLatestTransaction = (transactions?: ITransaction[]): ITransaction | null => {
  if (!transactions || transactions.length === 0) {
    return null
  }

  return transactions.reduce((latest, current) => {
    const latesttr = latest.id ?? 0
    const currenttr = current.id ?? 0
    return currenttr > latesttr ? current : latest
  })
}

